import React from 'react';
import IconAnimation from '@/components/BannerAI/media/AiAnimation.webp';
import MaiaIconImage from '@/media/MaiaIA/iconImage.png';
import listeningImage from '@/media/MaiaIA/listening.png';
import * as S from './Header.styles';

const Header = ({
  betaTag, title, firstname, testId = 'header', isRecording,
}) => {
  const titleText = typeof title === 'function' ? title(firstname) : title;

  const defaultImage = MaiaIconImage || IconAnimation;

  return (
    <S.Header data-testid={testId}>
      <S.BetaTag>{betaTag}</S.BetaTag>
      <S.TitleWrapper>
        <S.MaiaIcon src={isRecording ? listeningImage : defaultImage} />
        <S.Title>{titleText}</S.Title>
      </S.TitleWrapper>
    </S.Header>
  );
};

export default Header;
